module.exports = __webpack_public_path__ + "img/travelService-new-two.30be3e10.png";